export default {
    data(){
        return{
    en: {
      /* ===================== CONTACT US TITLE ======================*/
  
      contact_us_title: "Headquater",
  
      /* ===================== ADDRESS ======================*/
  
      contact_us_address: "Address: Nottingham Innovation and Entrepreneurship Building, Yinzhou, Ningbo, China",
  
        /* ===================== PHONE NO ======================*/

      contact_us_phone_no: "Phone no : +86 19883038871",

      /* ===================== EMAIL ======================*/
  
      contact_us_email: "Email: dankao.chen@nxtech.pub",

      /* ===================== PATNERSHIP ======================*/

      contact_us_patnership: "Patnership: +86 19883038871"
    }
  }
  }
  };
  